import Vue from 'vue'
import Vuex from 'vuex'
import Dexie from 'dexie'
import { catalogClient } from './catalogClient'
import moment from 'moment'
import { EventBus } from './event-bus'


var db = new Dexie('database')

db.version(2).stores({
	products:
		'id,*sites, state, ean, pgzNumber, name, marketingName, brandId, subBrandId, categoryId, subCategoryId, subSubCategoryId, subSubSubCategoryId, price, orderQuantity',
	orders: 'id, added, client, cart',
	clients: 'id, name, address',
	brands: 'id, name, state',
	subBrands: 'id, name, state',
	categories: 'id, name, state',
	subCategories: 'id, name, state',
	subSubCategories: 'id, name, state',
	subSubSubCategories: 'id, name, state'
})
db.version(1).stores({
	products:
		'id, state, ean, pgzNumber, name, marketingName, brandId, subBrandId, categoryId, subCategoryId, subSubCategoryId, subSubSubCategoryId, price, orderQuantity',
	orders: 'id, added, client, cart',
	clients: 'id, name, address',
	brands: 'id, name, state',
	subBrands: 'id, name, state',
	categories: 'id, name, state',
	subCategories: 'id, name, state',
	subSubCategories: 'id, name, state',
	subSubSubCategories: 'id, name, state'
})

Vue.use(Vuex)
Vue.filter('date', function(value) {
	const lang = store.state.app.language
	if (!value) return ''
	moment.locale(lang + '-be')
	return moment(value).format('LLL')
})
Vue.filter('price', function(value) {
	var price = value.amount / 100
	if (!isNaN(price)) {
		price = price.toLocaleString('nl-NL', {
			style: 'currency',
			currency: value.currency
		})
	} else {
		price = 0
		price = price.toLocaleString('nl-NL', {
			style: 'currency',
			currency: 'EUR'
		})
	}
	return price
})
export const store = new Vuex.Store({
	state: {
		app: {
			language: 'nl',
			sidemenu: false,
			activeOrder: '',
			sound: window.localStorage.sound,
			syncing: {
				threads: 0,
				state: false
			},
			isLoaded: window.localStorage.isLoaded,
			user: {},
			userFilters:{
				sites: []
			},
			useOfflineSearch: false
		},
		products: [],
		clients: [],
		orders: [],
		retailerClient: null,
	},
	mutations: {
		sync(state, status) {
			if (status === true) {
				state.app.syncing.threads++
				state.app.syncing.state = status
			} else {
				state.app.syncing.threads--
				if (!state.app.syncing.threads) {
					state.app.syncing.state = status
				}
			}
		},
		setClients(state, payload){
			let deleted = payload.deletedItems
			let newItems = payload.newItems
			let total = deleted.length + newItems.length
			let processed = 0

			function updateLoadingState(){
				let loadingPercentage = Math.ceil((processed/total) * 100)
				// state intialisation is bundled
				EventBus.$emit('loadingStatus', {
					type: 'initClients',
					loadingPercentage
				})
				processed++
			}
			// remove items
			deleted.forEach(item =>{
				let index = state.clients.findIndex(storeItem => {
					return storeItem.id === item.id
				})
				state.clients.splice(index, 1)
				updateLoadingState()
			})

			// add new items
			newItems.forEach(item => {
				let index = state.clients.findIndex(storeItem => {
					return storeItem.id === item.id
				})

				if(index >= 0){
					state.clients.splice(index, 1, item)
				}else{
					state.clients.push(item)
				}
				updateLoadingState()
			})
		},

		setProductsInState(state, newState) {
			function setLoadingState(val){
				// state intialisation is bundled
				EventBus.$emit('loadingStatus', {
					type: 'initProducts',
					loadingPercentage: val
				})
			}
			state.products = newState.products
			setLoadingState(60)
			state.brands = newState.brands
			setLoadingState(65)
			state.subBrands = newState.subBrands
			setLoadingState(70)
			state.categories = newState.categories
			setLoadingState(75)
			state.subCategories = newState.subCategories
			setLoadingState(85)
			state.subSubCategories = newState.subSubCategories
			setLoadingState(90)
			state.subSubSubCategories = newState.subSubSubCategories
			setLoadingState(95)
			state.app.syncing.threads--
			setLoadingState(100)
			if (!state.app.syncing.threads) {
				state.app.syncing.state = status
			}

		},
		addProductToOrder(state, payload) {
			// Find current order
			var order = state.orders.find(function(foundOrder) {
				return foundOrder.id === payload.orderId
			})
			// Set right order amount
			payload.product.amount = payload.product.orderQuantity

			// Add product to order
			order.cart.push(payload.product)

			// Update order in local db
			Dexie.spawn(function*() {
				var orders = yield db.orders
				orders.update(payload.orderId, {
					cart: order.cart
				})
			})
		},
		updateCart(state, payload) {
			var orderIndex = state.orders.findIndex(function(order) {
				return order.id === state.app.activeOrder
			})
			state.orders[orderIndex].cart = new Array()
			Vue.set(state.orders[orderIndex], 'cart', payload)

			Dexie.spawn(function*() {
				var orders = yield db.orders
				orders.update(state.app.activeOrder, {
					cart: payload
				})
			})
		},
		updateProductToOrder(state, payload) {
			// Find current order
			var order = new Object(
				state.orders.find(function(foundOrder) {
					return foundOrder.id === payload.orderId
				})
			)

			// Find product
			var productIndex = order.cart.findIndex(function(foundProduct) {
				return foundProduct.ean === payload.product.ean
			})

			if (!payload.product.remove) {
				// Update product
				order.cart[productIndex] = payload.product
			} else {
				// remove product
				order.cart.splice(productIndex, 1)
			}

			// Update order in local db
			Dexie.spawn(function*() {
				var orders = yield db.orders
				orders.update(payload.orderId, {
					cart: order.cart
				})
			})
		},
		updateOrders(state, order) {
			if (order.added) {
				// Add single order
				state.orders.push(order)
			} else {
				// Add bulk orders (eg from local db)
				state.orders = order
			}

			// Add orders to local db
			Dexie.spawn(function*() {
				var orders = yield db.orders

				orders.bulkPut(state.orders).catch(err => {
					console.error('Uh oh! ' + err.stack)
					EventBus.$emit('error', err)
				})
			})
		},
		setActiveOrder(state, id) {
			state.app.activeOrder = id
		},
		removeOrder(state, id) {
			// find id
			var orderIndex = state.orders.findIndex(function(order) {
				return order.id === id
			})

			// remove from store
			state.orders.splice(orderIndex, 1)

			// Remove order from local db
			Dexie.spawn(function*() {
				var orders = yield db.orders
				orders
					.where('id')
					.equals(id)
					.delete()
					.catch(err => {
						console.error('Uh oh! ' + err.stack)
						EventBus.$emit('error', err)
					})
			})
		},
		sidemenu(state, view) {
			state.app.sidemenu = view
		},
		sound(state, setting) {
			window.localStorage.sound = setting
			state.app.sound = setting
		},
		updateUser(state, user) {
			state.app.user = user
			state.app.userFilters.sites.push(user.profile.site)
		},
		selectLanguage(state, lang) {
			state.app.language = lang
			localStorage.language = lang
		},
		isRetailer(state, payload) {
			state.retailerClient = payload
		},
		setLoaded(state, status) {
			window.localStorage.isLoaded = status
			state.app.isLoaded = status
		},
		toggleOfflineSearchUsage(state, newState){
			state.app.useOfflineSearch = newState
			window.localStorage.offlineSearch = newState
		}
	},
	actions: {
		updateClients(store, data) {
			return new Promise(resolve =>{
				// all indexeddb stuff is handled in actions because mutations can't have async
				let newItems = []
				let deletedItems = []
				let init = data.init
				db.transaction('rw', db.clients, async() =>{
					var clients = await db.clients
					for (let i = 0; i < data.clients.length; i++) {
						const client = data.clients[i]
						let loadingPercentage = Math.ceil((i/data.clients.length)*100)

						EventBus.$emit('loadingStatus', {
							type: 'clientsIndex',
							loadingPercentage
						})
						if (client.state === 'disabled') {
							clients
								.where('id')
								.equals(client.id)
								.delete(client)
							deletedItems.push(client)
						} else {
							clients.put(client)
							newItems.push(client)
						}
					}
				}).then(async ()=>{
					// send changes to store
					if(!init){
						this.commit('setClients', {newItems, deletedItems})
						resolve('Updated customers: '+ newItems.length+ ' new and '+ deletedItems + 'disabled')
					}else{
					// get all stuff from indexedDB and put in the store
						let allClients = await store.getters.getClientsFromIndexedDb
						await this.commit('setClients', {
							newItems: allClients.newItems,
							deletedItems: []
						})
						resolve('Initiated customers: '+ allClients.newItems.length)
					}
				}).catch(e => {
					console.error(e)
					EventBus.$emit('error', e)
					resolve('Failed to update customers: '+ e)
				})
			})
		},
		updateProducts(state, data) {
			return new Promise((resolve, reject) =>{
				db.transaction('rw', db.products,
					db.brands,
					db.subBrands,
					db.categories,
					db.subCategories,
					db.subSubCategories,
					db.subSubSubCategories, async() =>{
						function putInDB(table, item) {
							let items = []
							let deleted = []
							let tableName = table.name

							item.forEach((i, index) => {
								if (i.state === 'disabled') {
									deleted.push(i)
								} else {
									items.push(i)
								}
								let loadingPercentage = Math.ceil((index/item.length)*100)
								EventBus.$emit('loadingStatus', {
									type: tableName + 'Index',
									loadingPercentage
								})
							})

							table.bulkPut(items).catch(Dexie.BulkError, function(e) {
								console.error('Error: addClientsToDb has failed - ' + e)
								EventBus.$emit('error', e)
							}).then(()=>{
								EventBus.$emit('loadingStatus', {
									type: tableName + 'Index',
									loadingPercentage: 100
								})
							})

							deleted.forEach(i => {
								table
									.where('id')
									.equals(i.id)
									.delete(i)
							})
						}
						var products = await db.products
						putInDB(products, data.products)
						var brands = await db.brands
						putInDB(brands, data.brands)
						var subBrands = await db.subBrands
						putInDB(subBrands, data.subBrands)
						var categories = await db.categories
						putInDB(categories, data.categories)
						var subCategories = await db.subCategories
						putInDB(subCategories, data.subCategories)
						var subSubCategories = await db.subSubCategories
						putInDB(subSubCategories, data.subSubCategories)
						var subSubSubCategories = await db.subSubSubCategories
						putInDB(subSubSubCategories, data.subSubSubCategories)
					}).then(()=>{
					resolve()
				}).catch(e=>{
					reject(e)
				})
			})

		},
		toggleSidemenu(store, action) {
			switch (action) {
			case 'open':
				store.commit('sidemenu', true)
				break
			case 'close':
				store.commit('sidemenu', false)
				break
			default:
				store.commit('sidemenu', !store.state.app.sidemenu)
				break
			}
		},
		getClients(store, user) {
			return new Promise((resolve, reject) => {
				store.commit('sync', true)
				try {
					const data = catalogClient.getClients(
						{
							uri: 'https://pgz-gateway.nextchapter-ecommerce.com/',
							access_token: user ? user.access_token : null,
							appVersion: window.appVersion,
							env: process.env.VUE_APP_ENV
						},
						window.localStorage.getItem('lastUpdateClients')
					)
					resolve(data)
				} catch (e) {
					reject(e)
				}
			}).finally(()=>{
				store.commit('sync', false)
			})
		},
		getProducts(store, user) {
			return new Promise((resolve, reject) => {
				store.commit('sync', true)
				try {
					const data = catalogClient.getProducts(
						{
							uri: 'https://pgz-gateway.nextchapter-ecommerce.com/',
							access_token: user ? user.access_token : null,
							appVersion: window.appVersion,
							env: process.env.VUE_APP_ENV,
							user
						},
						window.localStorage.getItem('lastUpdateProducts')
					)
					resolve(data)
				} catch (e) {
					reject(e)
				}
			})
		},
		async setProductsInState(state) {
			var newState = {}
			var userFilters = this.getters.userFilters

			async function getFromDB(db, item) {
				let data = await db.toArray()
				newState[item] = data
			}

			function setLoadingState(val){
				// state intialisation is bundled
				EventBus.$emit('loadingStatus', {
					type: 'initProducts',
					loadingPercentage: val
				})
			}
			setLoadingState(0)

			await getFromDB(db.brands, 'brands')
			setLoadingState(5)
			await getFromDB(db.subBrands, 'subBrands')
			setLoadingState(10)

			let productData = await db.products.where('sites').anyOf(userFilters.sites).toArray()
			newState['products'] = productData

			for (let i = 0; i < newState.products.length; i++) {
				const product = newState.products[i]
				if (product.state !== 'disabled') {
					if (product.brandId) {
						product.content.nl.brand = newState.brands.find(
							brand => brand.id === product.brandId
						).content.nl.name
						product.content.fr.brand = newState.brands.find(
							brand => brand.id === product.brandId
						).content.fr.name
					}
					if (product.subBrandId) {
						product.content.nl.subBrand = newState.subBrands.find(
							brand => brand.id === product.subBrandId
						).content.nl.name
						product.content.fr.subBrand = newState.subBrands.find(
							brand => brand.id === product.subBrandId
						).content.fr.name
					}
				}
			}
			setLoadingState(30)

			await getFromDB(db.categories, 'categories')
			setLoadingState(35)
			await getFromDB(db.subCategories, 'subCategories')
			setLoadingState(40)
			await getFromDB(db.subSubCategories, 'subSubCategories')
			setLoadingState(45)
			await getFromDB(db.subSubSubCategories, 'subSubSubCategories')
			setLoadingState(50)

			state.commit('setProductsInState', newState)
		},
		getOrders(store) {
			return new Promise((resolve, reject) => {
				store.commit('sync', true)
				try {
					Dexie.spawn(function*() {
						var allOrders = yield db.orders
						var orders = []

						allOrders
							.orderBy('added')
							.desc()
							.each(function(order) {
								orders.push(order)
							})
							.then(() => {
								store.commit('updateOrders', orders)
								resolve()
							})
					}).catch(err => {
						console.error('Uh oh! ' + err.stack)
						EventBus.$emit('error', err)
					})
				} catch (e) {
					EventBus.$emit('error', e)
					reject(e)
				}
			})
		},
		newOrder(store, order) {
			store.commit('updateOrders', order)
		},
		async isRetailer(store){
			let email = await store.getters.user.profile.email
			const clients = await store.getters.getClients
			let clientStore = clients.find(function(client) {
				return email === client.contact.email
			})
			if(clientStore){
				store.commit('isRetailer', clientStore.id)
			}
		}
	},
	getters: {
		product(state) {
			return function(ean) {
				return state.products.find(function(product) {
					return ean === product.ean
				})
			}
		},
		productById(state) {
			return function(id) {
				return state.products.find(function(product) {
					return id === product.id
				})
			}
		},
		productInOrder(state, getters) {
			return function(id) {
				var activeOrder = getters.order
				var cart = activeOrder.cart
				return cart.find(function(order) {
					return order.id === id
				})
			}
		},
		order(state) {
			var activeOrder = state.app.activeOrder
			var orderIndex = state.orders.findIndex(function(order) {
				return order.id === activeOrder
			})
			return state.orders[orderIndex]
		},
		orderById(state) {
			return function(id) {
				return state.orders.find(function(orders) {
					return id === orders.id
				})
			}
		},
		cart(state, getters) {
			if (getters.order) {
				return getters.order.cart
			} else {
				return ''
			}
		},
		idToItem(state) {
			return function(id) {
				var foundIn

				function findIn(type) {
					var found = state[type].find(function(item) {
						return item.id === id
					})
					if (found) {
						foundIn = found
						foundIn.type = type
					}
				}
				findIn('brands')
				findIn('subBrands')
				findIn('categories')
				findIn('subCategories')
				findIn('subSubCategories')
				findIn('subSubSubCategories')
				let filter = foundIn
				return filter
			}
		},
		lastOrder(state) {
			return state.orders[state.orders.length - 1]
		},
		syncing(state) {
			return state.app.syncing.state
		},
		user(state) {
			return state.app.user
		},
		getClients(state) {
			return state.clients
		},
		getRetailerClient(state) {
			return state.clients.find(function(client) {
				return state.retailerClient === client.id
			})
		},
		getSingleClient(state) {
			return function(id) {
				return state.clients.find(function(client) {
					return id === client.id
				})
			}
		},
		getClientsFromIndexedDb() {
			return new Promise((resolve, reject)=>{
				// all indexeddb stuff is handled in actions because mutations can't have async
				let newItems = []
				let deletedItems = []
				db.transaction('rw', db.clients, async() =>{
					var clients = await db.clients
					clients.each(function(client) {
						newItems.push(client)
					})
				}).then(()=>{
					resolve({newItems, deletedItems})
				}).catch(e => {
					reject(e)
				})
			})

		},
		language(state) {
			return state.app.language
		},
		loaded(state) {
			return state.app.isLoaded
		},
		getOrderList(state) {
			// give the open orders list back sort by creation date;
			return state.orders.sort(function(a, b) {
				let dateA = new Date(a.added)
				let dateB = new Date(b.added)
				return dateB - dateA // sort by date decending
			})
		},
		offlineSearch(state){
			return state.app.useOfflineSearch
		},
		userFilters(state){
			return state.app.userFilters
		}
	}
})
